module.exports = __webpack_public_path__ + "img/img-travelins.e18e42d8.png";